import { Component, OnInit, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "../../store/state/app.state";
import { SetGlobalSettingModalVisibility } from "src/app/store/actions/global-user-settings.actions";
import { GlobalUserSettings } from "src/app/store/models/global-user-settings.model";
import { VAIconRegistryService, cog } from "@va/core-library/icons";

@Component({
  selector: "app-global-user-settings-button",
  templateUrl: "./global-user-settings-button.component.html",
  styleUrls: ["./global-user-settings-button.component.scss"],
})
export class GlobalUserSettingsButtonComponent implements OnInit {
  @Input() class = "";
  @Input() disabled = false;
  @Input() showText = true;
  isVisibleEteModal = false;

  constructor(
    private store: Store<AppState>,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([cog]);
  }

  ngOnInit() {
    this.store
      .select(stateGetter("globalUserSettings"))
      .subscribe((globalUserSettings: GlobalUserSettings) => {
        this.isVisibleEteModal =
          globalUserSettings && globalUserSettings.modalSettings
            ? globalUserSettings.modalSettings.isVisibleEteModal
            : false;
      });
  }

  onGlobalSettingsBtnClick() {
    this.store.dispatch(new SetGlobalSettingModalVisibility(true));
  }
}
